import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';

import { ScreenTopBar, IScreenTopBarProps } from '@components';
import { useDebouncedCallback, useNavOptionsSet } from '@hooks';
import { SearchTabNavigatorContext } from '@context';
import {
  AnalyticsService,
  AnalyticGlobalSearchEventTypeEnum,
} from '@services';

interface ISearchTabHeaderProps
  extends Pick<IScreenTopBarProps, 'initSearchText'> {}

export const SearchTabHeader = observer(
  ({ initSearchText }: ISearchTabHeaderProps) => {
    const { t } = useTranslation();
    const searchTabNavigator = useContext(SearchTabNavigatorContext);

    useNavOptionsSet({
      title: t('search.title'),
    });

    const updateSearchQuery = useDebouncedCallback(
      (text) => {
        searchTabNavigator.setQuery(text);
        AnalyticsService.trackGlobalSearch(
          text,
          AnalyticGlobalSearchEventTypeEnum.Dynamic,
        );
      },
      [],
      400,
    );

    return (
      <ScreenTopBar
        title={Platform.select({
          web: t('search.title'),
        })}
        withSearchAutofocus
        onSearchChange={updateSearchQuery}
        initSearchText={initSearchText}
      />
    );
  },
);
